import { QuotePanelWithChildren } from '@pages/QuoteDetails/QuotePanelWithChildren';
import Loading from '@components/Loading';
import { Grid } from '@mui/material';
import { useQuoteStore } from '@store/Quote/QuoteStore';

type QuotePanelsProps = {
  quoteId: string;
  disabled: boolean;
  isLoading: boolean;
};

export function QuotePanels({ quoteId, disabled, isLoading }: QuotePanelsProps) {
  const { panelInstances, panelInstancesByParentInstanceId } = useQuoteStore((state) => ({
    panelInstances: state.panelInstances,
    panelInstancesByParentInstanceId: state.panelInstancesByParentInstanceId,
  }));
  const topPanels = panelInstances.filter((panel) => !panel.parentPanelInstanceId);

  return !isLoading ? (
    <>
      {topPanels.map((panel) => (
        <QuotePanelWithChildren
          key={panel.panelInstanceId}
          disabled={disabled}
          quoteId={quoteId}
          panel={panel}
          level={0}
          panelInstancesByParentInstanceId={panelInstancesByParentInstanceId}
        />
      ))}
    </>
  ) : (
    <Grid
      sx={{
        alignSelf: 'center',
        marginTop: '20%',
      }}
    >
      <Loading />
    </Grid>
  );
}
